globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Emailing = appCustomerSpace.Controllers.Emailing || {};

appCustomerSpace.Controllers.Emailing.MainController = (function (superClass) {

  utils.extend(MainController, superClass);

  function MainController() {
    return MainController.__super__.constructor.apply(this, arguments);
  }

  $.extend(MainController.prototype, {
    init: function () {
      var $loaderPlaceHolder = $('.loader-placeholder');

      if ($loaderPlaceHolder.length) {
        appCustomerSpace.Loader().start({$container: $loaderPlaceHolder, options: {text: false, style: { spinner: {marginBottom: "0px"}}}});
      }
      this.initRefreshScreenshotButton();
      return MainController.__super__.init.apply(this, arguments);
    },
    initRefreshScreenshotButton: function () {
      var controller = this;

      $(document).on('click', '.email-content-refresh-btn a', function (e) {
        e.preventDefault();
        var $btn = $(this);
        var url = $btn.data('url');
        var contentUniqKey = $btn.data('content-uniq-key');
        var $element = $('#email-content-' + contentUniqKey);

        $btn.addClass('disabled');

        if ($element.length) {
          var $loader = $($btn.data('loader-html'));
          $element.replaceWith($loader);
          appCustomerSpace.Loader().start({$container: $loader, options: {text: false, style: { spinner: {marginBottom: "0px"}}}});
        }

        $.ajax({
          url: url,
          method: 'POST',
          success: function (data) {
            if (data.response === 1 && data.html) {
              var $current = $('#email-content-' + contentUniqKey);
              if ($current.length) {
                $current.replaceWith($(data.html));
              }
            }
          },
          complete: function () {
            $btn.removeClass('disabled');
          }
        });
      });
    },
    initAiAutoEditoToggle: function () {
      $(document).on('change', '.js-ai-auto-edito-checkbox', function () {
        var $alert = $('.js-ai-auto-edito-alert');

        if ($(this).is(':checked')) {
          $alert.removeAttr('hidden');
        } else {
          $alert.attr('hidden', 'hidden');
        }
      });
    },
    initActionCableContentChannel: function (params) {
      var controller = this;

      if (!params.project_uniq_key) {
        return;
      }

      App.cable.subscriptions.create({
        channel: "CustomerSpace::Emailing::Email::ContentChannel",
        project_uniq_key: params.project_uniq_key
      }, {
        received: function(data) {
          switch (data.action) {
            case 'update_thumbnail':
              var $element = $(`#email-content-${data.content_uniq_key}`);

              if($element.length) {
                $element.replaceWith($(data.html));
              }
              break;
            case 'email_content_ready':
              if (params.expected_newsletter_uniq_key && data.newsletter_uniq_key === params.expected_newsletter_uniq_key) {
                window.location.assign(data.redirect_url);
              }
              break;
            default:
              console.log('Invalid action :', data.action);
          }
        }
      });
    }
  });

  return MainController;

})(appCustomerSpace.Controllers.MainController);
